import { PortableTextReactComponents } from "next-sanity";
import { urlFor } from "./image";
import Image from "next/image";

export const PortableTextComponents: PortableTextReactComponents = {
  block: {
    h1: ({ children }) => (
      <h1 className="font-Satoshi-Variable text-5xl md:text-6xl lg:text-7xl">
        {children}
      </h1>
    ),
    h2: ({ children }) => (
      <h2 className="font-Satoshi-Variable text-4xl md:text-5xl lg:text-6xl">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="font-Satoshi-Variable text-3xl md:text-4xl lg:text-5xl">
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4 className="font-Satoshi-Variable text-2xl md:text-3xl lg:text-4xl">
        {children}
      </h4>
    ),
    h5: ({ children }) => (
      <h5 className="font-Satoshi-Variable text-xl md:text-2xl lg:text-3xl">
        {children}
      </h5>
    ),
    h6: ({ children }) => (
      <h6 className="font-Satoshi-Variable text-lg md:text-xl lg:text-2xl">
        {children}
      </h6>
    ),
  },
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) {
        return null;
      }

      return (
        <Image
          src={urlFor(value).width(800).auto("format").url()}
          alt={value.alt ?? "Sanity Image"}
          style={{ maxWidth: "100%", height: "auto" }}
        />
      );
    },
  },
  marks: {
    strong: ({ children }) => <strong className="font-bold">{children}</strong>,
    em: ({ children }) => (
      <em className="font-Satoshi-VariableItalic">{children}</em>
    ),
    b: ({ children }) => (
      <b className="font-Satoshi-BlackItalic text-orange-500">{children}</b>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="mb-4 list-disc pl-5 text-gray-800">{children}</ul>
    ),
    number: ({ children }) => (
      <ol className="mb-4 list-decimal pl-5 text-gray-800">{children}</ol>
    ),
  },
  listItem: {
    bullet: ({ children }) => <li className="text-base">{children}</li>,
  },
  hardBreak: () => <br />,
  unknownMark: ({ children }) => <span>{children}</span>,
  unknownType: ({ value }) => (
    <pre>Unknown type: {JSON.stringify(value, null, 2)}</pre>
  ),
  unknownBlockStyle: ({ children }) => <div>{children}</div>,
  unknownList: ({ children }) => <ul>{children}</ul>,
  unknownListItem: ({ children }) => <li>{children}</li>,
};
